export default function LoadingSpinner({ size = 'md' }) {
  const dim = size === 'sm' ? '1rem' : size === 'lg' ? '3rem' : '1.5rem';
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '2rem' }}>
      <div
        style={{
          width: dim,
          height: dim,
          border: '3px solid var(--color-border-neutral)',
          borderTopColor: 'var(--color-info-text)',
          borderRadius: '50%',
          animation: 'spin 0.7s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
